<template>
	<div class="builder-row">
		<p class="title-column">{{ title }}</p>
		<input
			type="text"
			:value="url"
			@input="$emit('update:url', $event.target.value)"
			:placeholder="placeholder"
			autofocus
		/>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		placeholder: String,
		url: String,
	},
};
</script>